import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    :host {
        display: block;
    }

    .div-icon-inner {
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        transform: translate(-50%, 0px);
        align-items: center;
    }

    .div-icon-inner sl-icon {
        font-size: 2em;
    }

    .div-icon-inner .body {
        display: flex;
        flex-direction: column;
        gap: 0.2em;
        align-items: center;
        background-color: white;
        border-radius: 0.45em;
        padding: 0.45em;
        margin-top: -8px;
    }

    .div-icon-inner .body .row {
        display: flex;
        flex-direction: row;
        gap: 0.2em;
        align-items: center;
    }

    .div-icon-inner span {
        color: black;
    }

    .div-icon-circle {
        width: 100%;
        height: 0.6em;
        border-radius: 5%;
    }

    hr {
        width: 100%;
        color: black;
    }

    .info-title {
        font-size: 1.3em;
    }

    .info-type {
        font-variant-caps: all-petite-caps;
        font-size: 1.3em;
    }

    .header {
        gap: 0em;
    }

    .type-row {
        margin-top: -0.3em;
    }

    .warning-icon {
        color: black;
        font-size: 1.2em;
        padding-right: 0.3em;
    }

    .warning-row {
        justify-content: flex-end;
        margin-top: 0.5em;
    }
`;
